import { i18n } from '@/plugins/i18n';

export const bankCodes = {
    MARKAZI: '010',
    SANAT_MADAN: '011',
    MELLAT: '012',
    REFAH: '013',
    MASKAN: '014',
    SEPAH: '015',
    KESHAVARZI: '016',
    MELLI: '017',
    TEJARAT: '018',
    SADERAT: '019',
    TOSEE_SADERAT: '020',
    POST_BANK: '021',
    TOSEE_TAAVON: '022',
    TOSEE: '051',
    GHAVAMIN: '052',
    KARAFARIN: '053',
    PARSIAN: '054',
    EGHTESAD_NOVIN: '055',
    SAMAN: '056',
    PASARGAD: '057',
    SARMAYE: '058',
    SINA: '059',
    MEHR_IRAN: '060',
    SHAHR: '061',
    AYANDE: '062',
    ANSAR: '063',
    GARDESHGARI: '064',
    HEKMAT_IRANIAN: '065',
    DAY: '066',
    IRAN_ZAMIN: '069',
    RESALAT: '070',
    MEHR_IRAN_2: '090',
    IRAN_VENEZUELA: '095',
    NOOR: '080',
    KOSAR: '073',
    MELAL: '075',
    KHAVARMIANE: '078',
    MEHR_EGHTESAD: '079'
};

export const bankIdStr = {
    MARKAZI: i18n.t('accounting.bank_name.markazi'),
    SANAT_MADAN: i18n.t('accounting.bank_name.sanat_madan'),
    MELLAT: i18n.t('accounting.bank_name.mellat'),
    REFAH: i18n.t('accounting.bank_name.refah'),
    MASKAN: i18n.t('accounting.bank_name.maskan'),
    SEPAH: i18n.t('accounting.bank_name.sepah'),
    KESHAVARZI: i18n.t('accounting.bank_name.keshavarzi'),
    MELLI: i18n.t('accounting.bank_name.melli'),
    TEJARAT: i18n.t('accounting.bank_name.tejarat'),
    SADERAT: i18n.t('accounting.bank_name.saderat'),
    TOSEE_SADERAT: i18n.t('accounting.bank_name.tosee_saderat'),
    POST_BANK: i18n.t('accounting.bank_name.post_bank'),
    TOSEE_TAAVON: i18n.t('accounting.bank_name.tosee_taavon'),
    TOSEE: i18n.t('accounting.bank_name.tosee'),
    GHAVAMIN: i18n.t('accounting.bank_name.ghavamin'),
    KARAFARIN: i18n.t('accounting.bank_name.karafarin'),
    PARSIAN: i18n.t('accounting.bank_name.parsian'),
    EGHTESAD_NOVIN: i18n.t('accounting.bank_name.eghtesad_novin'),
    SAMAN: i18n.t('accounting.bank_name.saman'),
    PASARGAD: i18n.t('accounting.bank_name.pasargad'),
    SARMAYE: i18n.t('accounting.bank_name.sarmaye'),
    SINA: i18n.t('accounting.bank_name.sina'),
    MEHR_IRAN: i18n.t('accounting.bank_name.mehr_iran'),
    SHAHR: i18n.t('accounting.bank_name.shahr'),
    AYANDE: i18n.t('accounting.bank_name.ayande'),
    ANSAR: i18n.t('accounting.bank_name.ansar'),
    GARDESHGARI: i18n.t('accounting.bank_name.gardeshgari'),
    HEKMAT_IRANIAN: i18n.t('accounting.bank_name.hekmat_iranian'),
    DAY: i18n.t('accounting.bank_name.day'),
    IRAN_ZAMIN: i18n.t('accounting.bank_name.iran_zamin'),
    RESALAT: i18n.t('accounting.bank_name.resalat'),
    MEHR_IRAN_2: i18n.t('accounting.bank_name.mehr_iran_2'),
    IRAN_VENEZUELA: i18n.t('accounting.bank_name.iran_venezuela'),
    NOOR: i18n.t('accounting.bank_name.noor'),
    KOSAR: i18n.t('accounting.bank_name.kosar'),
    MELAL: i18n.t('accounting.bank_name.melal'),
    KHAVARMIANE: i18n.t('accounting.bank_name.khavarmiane'),
    MEHR_EGHTESAD: i18n.t('accounting.bank_name.mehr_eghtesad'),

    get(bank_code) {
        let bank_name_str = null;

        Object.keys(bankCodes).forEach(function (item) {
            if (bankCodes[item] === bank_code) {
                bank_name_str = bankIdStr[item];
            }
        });

        return bank_name_str;
    }
};
